<template>
  <vx-card>
    <div class="vx-row">
      <div v-bind:class="[detail ? detailShow : '', detailHide]">
        <div class="vx-col sm:w-1/1 w-full mb-base">
          <vs-tabs>
            <vs-tab label="Stream Data Monitoring">
              <div class="tab-text">
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Date</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <date-range-picker
                      v-model="dateRange"
                      class="w-full"
                      :opens="'right'"
                      :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd' }"
                      :auto-apply="true"
                    />
                  </div>
                </div>
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Report Name</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <multiselect
                      class="selectExample"
                      v-model="reportNameSelected"
                      :options="optionReportName"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="180"
                      :limit="3"
                      track-by="value"
                      label="label"
                      multiple
                    />
                  </div>
                </div>
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Status</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <multiselect
                      class="selectExample"
                      v-model="statusSelected"
                      :options="optionStatus"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="120"
                      :limit="3"
                      track-by="value"
                      label="label"
                      multiple
                    />
                  </div>
                </div>
                <data-table
                  :baseUrl="this.baseUrl"
                  :detail="this.detail"
                  :date-from="this.dateFrom"
                  :date-to="this.dateTo"
                  :report-name="this.reportName"
                  :status="this.status"
                ></data-table>
              </div>
            </vs-tab>
            <vs-tab label="Export">
              <div class="tab-text">
                <data-table-export></data-table-export>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DateRangePicker from "vue2-daterange-picker";
import DataTable from "./DataTable.vue";
import DataTableExport from "./DataTableExport.vue";
import moment from "moment";
export default {
  components: {
    DataTableExport,
    DataTable,
    DateRangePicker
  },
  data() {
    return {
      detailShow: "core vx-col md:w-1/2 w-full mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,

      baseUrl: "/api/v1/monitoring/stream-data",

      dateRange: {
        startDate: null,
        endDate: null,
      },
      dateFrom: null,
      dateTo: null,
      reportNameSelected: [],
      statusSelected: [],
      reportName: [],
      status: [],
      optionReportName: [
        { label: "CIT", value: "CIT" },
        { label: "COH", value: "COH" },
        { label: "POD & EPOD", value: "POD & EPOD" },
        { label: "Shipment Plan", value: "Shipment Plan" },
        { label: "Sales Return", value: "Sales Return" },
        { label: "GIR", value: "GIR" },
        { label: "POD Return", value: "POD Return" },
        { label: "GR PO", value: "GR PO" },
        { label: "GR STO", value: "GR STO" },
        { label: "Sales Order", value: "Sales Order" },
        { label: "Billing", value: "Billing" },
        { label: "Billing Reversal", value: "Billing Reversal" },
        { label: "Billing Non Mix", value: "Billing Non Mix" },
        { label: "Billing Reversal Non Mix", value: "Billing Reversal Non Mix" },
        { label: "Credit Note", value: "Credit Note" },
        { label: "Credit Note Reversal", value: "Credit Note Reversal" },
        { label: "Credit Note Non Mix", value: "Credit Note Non Mix" },
        { label: "Credit Note Reversal Non Mix", value: "Credit Note Reversal Non Mix" },
        { label: "Order Status", value: "Order Status" },
      ],
      optionStatus: [
        { label: "Complete", value: "Complete" },
        { label: "Retry Complete", value: "Retry Complete" },
        { label: "Failed", value: "Failed" },
      ],
      draw: 0
    };
  },
  methods: {
    setDateFilter() {
      this.dateFrom = this.dateRange.startDate
        ? moment(this.dateRange.startDate).format("YYYY-MM-DD")
        : null;
      this.dateTo = this.dateRange.endDate
        ? moment(this.dateRange.endDate).format("YYYY-MM-DD")
        : null;
    },
  },
  mounted() {
    const today = new Date();
    this.dateRange = {
      startDate: new Date(today.getFullYear(), today.getMonth(), 1),
      endDate: today,
    };
    this.setDateFilter();
  },
  watch: {
    dateRange: {
      deep: true,
      handler() {
        this.setDateFilter();
      }
    },
    reportNameSelected() {
      if (this.reportNameSelected && this.reportNameSelected.length > 0) {
        this.reportName = this.reportNameSelected.map(item => item.value);
      } else {
        this.reportName = [];
      }
    },
    statusSelected() {
      if (this.statusSelected && this.statusSelected.length > 0) {
        this.status = this.statusSelected.map(item => item.value);
      } else {
        this.status = [];
      }
    },
  }
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}

/* Custom styling for info fields */
.info-field-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #4a5568;
}

.info-field-input .vs-input--input {
  background-color: #f7fafc;
  border-color: #e2e8f0;
  color: #2d3748;
  font-weight: 500;
}

.info-field-input .vs-input--input:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.1);
}

.info-field-input .vs-input--icon {
  color: #718096;
}
</style>
